/* =========================================================================
   PRESENTE DA ROLETA DA GIRE E GANHE (cópia separada, 20/10/2026)

   É o guarda `conferirPresenteRoleta` + o pop-up de tamanho do tp-presente.js
   de 02/10/2026 (commit e47eef9), tirados de lá para conviver com a roleta do
   SITE, que desde 05/10 usa o tp-presente.js com outras regras (Necessaire de
   R$ 79,90 a partir de R$ 399). Nada aqui lê ou grava as chaves do site.

   CONTRATO COM A ROLETA (assets/tp-roleta-gg.js, só em /collections/gire-e-ganhe):
     tp-rgg-presente           handle do presente (presente-misterioso-regata)
     tp-rgg-presente-minimo    centavos em peças da coleção para o presente entrar
     tp-rgg-presente-campanha  campanha em que foi ganho (snippet tp-rgg-campanha)
     tp-rgg-presente-variante  variante sorteada no pop-up de tamanho
     tp-rgg-presente-tamanho   tamanho escolhido

   A linha do carrinho leva `_roleta_gg` (e não `_roleta`): o guarda da roleta
   do site tira qualquer linha `_roleta` sem prêmio dele.

   AS REGRAS (as mesmas de 02/10):
   1. ganhou e tem R$ mínimo em peças PAGAS da coleção gire-e-ganhe -> 1 presente;
   2. abaixo disso ou sem peça da coleção -> nenhum presente;
   3. mais de uma linha ou quantidade > 1 -> volta para 1.
   ========================================================================= */
(function () {
  if (window.__tpRggPresente) return;
  window.__tpRggPresente = true;

  var CHAVES = ['tp-rgg-presente', 'tp-rgg-presente-minimo', 'tp-rgg-presente-variante', 'tp-rgg-presente-tamanho', 'tp-rgg-presente-campanha'];

  function lerDados() {
    var el = document.querySelector('[data-tp-rgg-dados]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var DADOS = lerDados();
  if (!DADOS) return;

  function ler(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function ehNossa(i) { return !!(i.properties && i.properties._roleta_gg); }
  function ehDeRoleta(i) { return !!(i.properties && (i.properties._roleta || i.properties._roleta_gg)); }

  function gaveta() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }
  function corpoComSecoes(base) {
    var c = gaveta();
    if (c && typeof c.getSectionsToRender === 'function') {
      base.sections = c.getSectionsToRender().map(function (s) { return s.id; });
      base.sections_url = window.location.pathname;
    }
    return base;
  }
  function redesenhar(res) {
    var c = gaveta();
    if (c && typeof c.renderContents === 'function') {
      if (c.classList.contains('is-empty')) c.classList.remove('is-empty');
      c.renderContents(res);
    }
  }
  function pedir(url, corpo) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) { return r.json(); });
  }
  function ajustar(chave, quantidade) {
    return pedir('/cart/change.js', corpoComSecoes({ id: chave, quantity: quantidade })).then(function (res) {
      if (res && res.status) throw new Error(res.description || res.message || 'falha ao ajustar');
      redesenhar(res);
    });
  }
  function lerCarrinho() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  /* Só lê o carrinho quando há o que conferir: prêmio gravado ou uma linha
     `_roleta_gg` conhecida (do Liquid ao carregar, ou da última leitura). Quem
     nunca girou a Gire e Ganhe não paga leitura nenhuma. */
  var linhaConhecida = !!DADOS.temLinha;
  /* Lê o carrinho a cada mudança dele (o presente vale para toda compra da coleção desde
     20/10); ao carregar, só com prêmio gravado, linha do presente ou peça da coleção. */
  function precisa() { return true; }
  function precisaAoCarregar() { return !!ler('tp-rgg-presente') || linhaConhecida || !!DADOS.temPeca; }

  var ocupado = false, falhou = false;

  /* SKUs com estoque na peça de verdade (a regata original da produtos-site-base). */
  async function skusComEstoque() {
    try {
      var p = await (await fetch('/products/' + encodeURIComponent(DADOS.estoque || 'blusa-slim-modeladora') + '.js', { cache: 'no-store' })).json();
      var s = {};
      (p.variants || []).forEach(function (x) { if (x.available && x.sku) s[x.sku] = true; });
      return s;
    } catch (e) { return null; }
  }
  function sortearMesmoTamanho(vs, tamanho, est) {
    var pool = (vs || []).filter(function (x) { return x.option1 === tamanho && x.available && x.sku && est[x.sku]; });
    return pool.length ? pool[Math.floor(Math.random() * pool.length)] : null;
  }
  function esquecerTamanho() {
    try { localStorage.removeItem('tp-rgg-presente-variante'); localStorage.removeItem('tp-rgg-presente-tamanho'); } catch (e) {}
  }
  /* =====================================================================
     TEXTOS DA MODA PRAIA NOVA (30/10/2026, Guilherme): nas PDPs gg da praia e com o
     conjunto/maiô no carrinho, nada de "a partir de R$ 299" -- o presente vai junto com o
     conjunto (top + calcinha) ou com o maiô. O pop-up de tamanho (buscado da home, o Liquid
     não sabe a página) e a descrição do prêmio na roleta (tp-roleta-gg.js) perguntam aqui.
       tpRggPraia.tipo()          'maio' | 'conjunto' | ''   (carrinho manda; senão a página)
       tpRggPraia.noCarrinho()    true quando o carrinho já libera o presente
     ===================================================================== */
  var praiaNoCarrinho = '';
  function praiaDaPagina() {
    var m = /\/products\/([^\/?#]+)/.exec(window.location.pathname || '');
    if (!m) return '';
    var h = decodeURIComponent(m[1]).toLowerCase(), p = DADOS.praia || {};
    if ((p.maios || []).indexOf(h) > -1) return 'maio';
    if ((p.calcinhas || []).indexOf(h) > -1 || (p.tops || []).indexOf(h) > -1 || (p.kits || []).indexOf(h) > -1) return 'conjunto';
    return '';
  }
  window.tpRggPraia = {
    tipo: function () { return praiaNoCarrinho || praiaDaPagina(); },
    noCarrinho: function () { return !!praiaNoCarrinho; }
  };

  async function conferirPresente(c) {
    var handle = ler('tp-rgg-presente');
    /* CAMPANHA ATUAL: presente ganho em outra campanha da Gire e Ganhe não vale. */
    try {
      if (handle && DADOS.campanha && ler('tp-rgg-presente-campanha') !== DADOS.campanha) {
        CHAVES.forEach(function (k) { localStorage.removeItem(k); });
        handle = null;
      }
    } catch (e) {}
    /* SEM GIRO TAMBÉM VALE (20/10/2026, pedido do Guilherme: a PDP fala do presente para
       todas): sem prêmio gravado, o presente e o mínimo vêm do tp-rgg-dados. */
    if (!handle) handle = DADOS.presente || null;

    if (ocupado) return;
    ocupado = true;
    try {
      var itens = c.items || [];
      var nossas = itens.filter(ehNossa);
      linhaConhecida = nossas.length > 0;
      var daColecao = {};
      (DADOS.ids || []).forEach(function (id) { if (id) daColecao[String(id)] = true; });
      var pagas = itens.filter(function (x) {
        return !ehDeRoleta(x) && x.final_line_price > 0 && daColecao[String(x.product_id)];
      });
      var minimo = parseInt(ler('tp-rgg-presente-minimo') || '0', 10) || DADOS.minimo || 0;
      var totalPagas = pagas.reduce(function (soma, x) { return soma + (x.final_line_price || 0); }, 0);
      /* PREÇO COM DESCONTO (03/11/2026, Guilherme, igual à roleta do site em tp-presente.js): o cupom
         de PEDIDO (BLUMI20, influs...) vem em cart_level_discount_applications e não mexe no
         final_line_price -- sai a parte dele que cabe às peças da coleção. Abaixo de R$ 299 com o
         desconto, o presente sai. */
      var descPedido = (c.cart_level_discount_applications || []).reduce(function (soma, d) { return soma + (d.total_allocated_amount || d.amount || 0); }, 0);
      if (descPedido > 0 && c.items_subtotal_price > 0) {
        totalPagas -= Math.round(descPedido * Math.min(1, totalPagas / c.items_subtotal_price));
      }

      /* MODA PRAIA NOVA (30/10/2026, Guilherme): conjunto (qualquer top + calcinha) ou maiô
         das cópias gg da praia levam o presente SEMPRE, abaixo do mínimo também. Lista em
         snippets/tp-rgg-praia (via tp-rgg-dados). O mínimo segue valendo para o resto. */
      var praia = DADOS.praia || {};
      function temPraia(lista) {
        return pagas.some(function (x) { return (lista || []).indexOf(String(x.handle || '')) > -1; });
      }
      var liberaPraia = temPraia(praia.maios) || (temPraia(praia.calcinhas) && temPraia(praia.tops));
      praiaNoCarrinho = liberaPraia ? (temPraia(praia.maios) ? 'maio' : 'conjunto') : '';
      /* Meio conjunto (só calcinha ou só top): o cartão diz qual peça falta, não "adicione R$ X". */
      var faltaPraia = '';
      if (!liberaPraia && temPraia(praia.calcinhas)) faltaPraia = 'o top';
      else if (!liberaPraia && temPraia(praia.tops)) faltaPraia = 'a calcinha';

      /* CARTÃO DO CARRINHO (20/10/2026): abaixo do mínimo, "adicione mais R$ X"; no
         mínimo sem tamanho escolhido, "escolha o tamanho". */
      cartaoAtualizar({
        handle: handle, minimo: minimo, totalPagas: totalPagas, temPagas: pagas.length > 0,
        semTamanho: !ler('tp-rgg-presente-variante'), liberado: liberaPraia, faltaPraia: faltaPraia
      });

      if (!handle || !pagas.length || (totalPagas < minimo && !liberaPraia)) {
        for (var r = 0; r < nossas.length; r++) await ajustar(nossas[r].key, 0);
        linhaConhecida = false;
        return;
      }

      /* TAMANHO: sem variante escolhida nada entra; com o mínimo batido é a hora
         de pedir o tamanho (uma vez por carregamento). */
      var varianteEscolhida = ler('tp-rgg-presente-variante');
      if (!varianteEscolhida) {
        for (var q = 0; q < nossas.length; q++) await ajustar(nossas[q].key, 0);
        linhaConhecida = false;
        window.tpRggTamanho.pedir();
        return;
      }

      if (!nossas.length) {
        if (falhou) return;
        try {
          var prod = await (await fetch('/products/' + encodeURIComponent(handle) + '.js')).json();
          var vs = prod.variants || [];
          var v = null;
          for (var k = 0; k < vs.length; k++) { if (String(vs[k].id) === String(varianteEscolhida) && vs[k].available) { v = vs[k]; break; } }
          if (!v) { for (k = 0; k < vs.length; k++) { if (vs[k].available) { v = vs[k]; break; } } }
          if (!v) return;
          /* ESTOQUE NA PEÇA DE VERDADE (20/10/2026): a cor foi sorteada quando a cliente
             escolheu o tamanho; se esgotou na regata original desde então, sorteia outra
             cor com estoque NO MESMO TAMANHO. Tamanho inteiro esgotado: não entra e o
             pop-up pede outro tamanho. Sem resposta da loja, segue como estava. */
          var est = await skusComEstoque();
          if (est && !(v.sku && est[v.sku])) {
            var novo = sortearMesmoTamanho(vs, v.option1, est);
            if (!novo) { esquecerTamanho(); window.tpRggTamanho.abrir(); return; }
            v = novo;
            try { localStorage.setItem('tp-rgg-presente-variante', String(novo.id)); } catch (e) {}
          }
          /* Só entra de graça: se o produto deixar de custar zero, para de entrar. */
          if (v.price !== 0) return;
          var res = await pedir('/cart/add.js', corpoComSecoes({
            items: [{ id: v.id, quantity: 1, properties: { _roleta_gg: '1' } }]
          }));
          if (res && res.status) throw new Error(res.description || res.message || 'falha ao adicionar');
          linhaConhecida = true;
          redesenhar(res);
        } catch (err) {
          console.error('[tp-rgg-presente] nao deu para colocar o presente da Gire e Ganhe', err);
          falhou = true;
        }
        return;
      }

      for (var j = 1; j < nossas.length; j++) await ajustar(nossas[j].key, 0);
      if (nossas[0].quantity > 1) await ajustar(nossas[0].key, 1);
      /* O PRESENTE JÁ NO CARRINHO COM COR QUE ESGOTOU: sai, e a próxima conferência põe
         outra cor do mesmo tamanho (ou pede outro tamanho). */
      var estL = await skusComEstoque();
      if (estL && !(nossas[0].sku && estL[nossas[0].sku])) {
        try {
          var prodL = await (await fetch('/products/' + encodeURIComponent(handle) + '.js')).json();
          var atual = (prodL.variants || []).filter(function (x) { return String(x.id) === String(nossas[0].variant_id); })[0];
          var trocaL = atual ? sortearMesmoTamanho(prodL.variants || [], atual.option1, estL) : null;
          if (trocaL) { try { localStorage.setItem('tp-rgg-presente-variante', String(trocaL.id)); } catch (e) {} }
          else esquecerTamanho();
        } catch (e) { esquecerTamanho(); }
        await ajustar(nossas[0].key, 0);
        linhaConhecida = false;
        agendarConferencia();
      }
    } catch (e) {
      console.error('[tp-rgg-presente]', e);
    } finally {
      ocupado = false;
    }
  }

  /* =====================================================================
     CARTÃO "ADICIONE MAIS R$ X E GANHE O PRESENTE MISTERIOSO" (20/10/2026)

     O mesmo cartão da roleta do site (tp-presente.js, classes .tp-pfaltam: escuro, no
     rodapé no celular, no canto direito no desktop, encostado à gaveta), com o estado
     da Gire e Ganhe. Só para quem girou e tem peça da coleção no carrinho:
       - abaixo do mínimo: "Adicione mais R$ X e ganhe o presente misterioso de R$ 189,90";
       - no mínimo, sem tamanho: "Escolha o tamanho do seu presente" (sem tamanho o
         presente não entra -- antes a cliente ficava sem saber por quê).
     "Ver as peças" / "Não, obrigada" calam por 30 minutos. Espera a roleta e o pop-up
     de tamanho fecharem.
     ===================================================================== */
  var VALOR_PRESENTE = 18990;
  var cRaiz = null;
  function brl(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function cMontar() {
    if (cRaiz) return cRaiz;
    var css = document.createElement('style');
    css.textContent = '.tp-pfaltam{position:fixed;z-index:2147483000;left:50%;bottom:16px;width:min(100% - 24px,380px);transform:translate(-50%,16px);opacity:0;display:flex;align-items:flex-start;gap:12px;padding:14px 16px 14px 14px;border-radius:16px;background:#222F28;color:#F1F0EB;box-shadow:0 10px 30px rgba(34,47,40,.28);font-family:var(--tp-body-font,"Host Grotesk",ui-sans-serif,system-ui,sans-serif);transition:opacity .22s ease,transform .22s ease}'
      + '.tp-pfaltam[hidden]{display:none}.tp-pfaltam.is-aberto{opacity:1;transform:translate(-50%,0)}'
      + '@media (min-width:750px){.tp-pfaltam{left:auto;right:20px;bottom:20px;transform:translateY(16px)}.tp-pfaltam.is-aberto{transform:translateY(0)}}'
      + '.tp-pfaltam__icone{flex:0 0 auto;width:38px;height:38px;border-radius:12px;background:rgba(255,170,153,.18);color:#FFAA99;display:inline-flex;align-items:center;justify-content:center}.tp-pfaltam__icone svg{width:20px;height:20px}'
      + '.tp-pfaltam__corpo{flex:1 1 auto;min-width:0}.tp-pfaltam__eyebrow{margin:0 0 2px;font-size:1.05rem;letter-spacing:.1em;text-transform:uppercase;color:#FFAA99;font-weight:600}'
      + '.tp-pfaltam__titulo{margin:0 0 4px;font-size:1.45rem;line-height:1.3;font-weight:600}.tp-pfaltam__titulo b{color:#FFAA99;font-weight:700}'
      + '.tp-pfaltam__texto{margin:0 0 10px;font-size:1.2rem;line-height:1.4;color:rgba(241,240,235,.78)}'
      + '.tp-pfaltam__acoes{display:flex;align-items:center;gap:14px;flex-wrap:wrap}'
      + '.tp-pfaltam__sim{display:inline-flex;align-items:center;padding:9px 14px;border-radius:999px;background:#FFAA99;color:#222F28;font-size:1.25rem;font-weight:700;text-decoration:none;border:0;font-family:inherit;cursor:pointer}'
      + '.tp-pfaltam__nao{border:0;background:transparent;padding:6px 2px;color:rgba(241,240,235,.75);font:inherit;font-size:1.2rem;text-decoration:underline;text-underline-offset:3px;cursor:pointer}'
      + '.tp-pfaltam--gg [hidden]{display:none!important}';
    document.head.appendChild(css);
    var el = document.createElement('div');
    el.className = 'tp-pfaltam tp-pfaltam--gg';
    el.setAttribute('role', 'status');
    el.hidden = true;
    el.innerHTML = '<span class="tp-pfaltam__icone" aria-hidden="true"><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M2.9 9.4h14.2v7.2a1 1 0 0 1-1 1H3.9a1 1 0 0 1-1-1V9.4z"/><path d="M2.1 6.6h15.8v2.8H2.1z"/><path d="M10 6.6v11"/><path d="M10 6.6S8.9 2.5 6.8 2.5a1.9 1.9 0 0 0 0 4.1H10z"/><path d="M10 6.6s1.1-4.1 3.2-4.1a1.9 1.9 0 0 1 0 4.1H10z"/></svg></span>'
      + '<div class="tp-pfaltam__corpo"><p class="tp-pfaltam__eyebrow">Presente misterioso</p><p class="tp-pfaltam__titulo" data-gg-titulo></p><p class="tp-pfaltam__texto" data-gg-texto></p>'
      + '<div class="tp-pfaltam__acoes"><a class="tp-pfaltam__sim" data-gg-sim href="/collections/gire-e-ganhe">Ver as peças</a><button type="button" class="tp-pfaltam__sim" data-gg-tam hidden>Escolher o tamanho</button><button type="button" class="tp-pfaltam__nao" data-gg-nao>Não, obrigada</button></div></div>';
    document.body.appendChild(el);
    function silenciar() { try { localStorage.setItem('tp-rgg-cartao-silencio', String(Date.now() + 30 * 60 * 1000)); } catch (e) {} }
    el.querySelector('[data-gg-nao]').addEventListener('click', function () { silenciar(); cFechar(); });
    /* "VER AS PEÇAS" (27/10/2026, Guilherme): na própria coleção gire-e-ganhe só fecha o cartão e a gaveta
       (se estiver aberta) -- as peças já estão ali atrás; numa PDP da campanha (ou em qualquer outra página)
       o link leva de volta para /collections/gire-e-ganhe. */
    el.querySelector('[data-gg-sim]').addEventListener('click', function (ev) {
      silenciar(); cFechar();
      if (!/^\/collections\/gire-e-ganhe\/?$/.test(window.location.pathname)) return;
      ev.preventDefault();
      var cd = document.querySelector('cart-drawer');
      try { if (cd && (cd.classList.contains('active') || cd.hasAttribute('open')) && typeof cd.close === 'function') cd.close(); } catch (e) {}
    });
    el.querySelector('[data-gg-tam]').addEventListener('click', function () { cFechar(); window.tpRggTamanho.abrir(); });
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) new MutationObserver(function () { setTimeout(cPosicionar, 350); }).observe(cd, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', cPosicionar);
    cRaiz = el;
    return el;
  }
  function cPosicionar() {
    if (!cRaiz) return;
    if (window.innerWidth < 750) { cRaiz.style.right = ''; return; }
    var cd = document.querySelector('cart-drawer.active, cart-drawer[open]');
    var painel = cd && (cd.querySelector('[class*="drawer__inner"]') || cd.firstElementChild);
    var r = painel && painel.getBoundingClientRect();
    cRaiz.style.right = (r && r.width > 0 && r.width < window.innerWidth - 100) ? (window.innerWidth - r.left + 16) + 'px' : '';
  }
  function cFechar() {
    if (!cRaiz || cRaiz.hidden) return;
    cRaiz.classList.remove('is-aberto');
    var el = cRaiz;
    setTimeout(function () { if (!el.classList.contains('is-aberto')) el.hidden = true; }, 240);
  }
  var cUltimo = null;
  function cartaoAtualizar(info) {
    cUltimo = info;
    var batido = info.totalPagas >= info.minimo || !!info.liberado;
    var falta = !!(info.handle && info.minimo > 0 && info.temPagas && !batido);
    var tamanho = !!(info.handle && info.temPagas && batido && info.semTamanho);
    if (!falta && !tamanho) { cFechar(); return; }
    var html = document.documentElement;
    if (html.classList.contains('tp-roleta-open') || html.classList.contains('tp-pt-open')) return;
    var silencio = 0;
    try { silencio = parseInt(localStorage.getItem('tp-rgg-cartao-silencio') || '0', 10) || 0; } catch (e) {}
    if (Date.now() < silencio) return;
    var el = cMontar();
    var titulo = el.querySelector('[data-gg-titulo]'), texto = el.querySelector('[data-gg-texto]');
    el.querySelector('[data-gg-sim]').hidden = !falta;
    el.querySelector('[data-gg-tam]').hidden = !tamanho;
    if (falta && info.faltaPraia) {
      /* MODA PRAIA NOVA (30/10/2026): com meio conjunto, a peça que falta já libera o presente. */
      titulo.innerHTML = 'Leve <b>' + info.faltaPraia + '</b> do biquíni e ganhe o presente misterioso de ' + brl(VALOR_PRESENTE);
      texto.textContent = 'Com o conjunto top + calcinha ele entra sozinho no carrinho.';
    } else if (falta) {
      titulo.innerHTML = 'Adicione mais <b>' + brl(info.minimo - info.totalPagas) + '</b> e ganhe o presente misterioso de ' + brl(VALOR_PRESENTE);
      /* Texto novo só nas páginas da Gire e Ganhe (27/10/2026); no resto do site, o de antes. */
      texto.textContent = /gire-e-ganhe/.test(window.location.pathname)
        ? 'Ele entra sozinho no carrinho em pedidos a partir de R$ 299 em peças da Gire e Ganhe.'
        : 'Ele entra no carrinho sozinho, por nossa conta.';
    } else {
      titulo.innerHTML = 'Escolha o tamanho do seu <b>presente misterioso</b>';
      texto.textContent = 'Sem o tamanho ele não entra no carrinho.';
    }
    if (el.hidden) { el.hidden = false; void el.offsetWidth; }
    el.classList.add('is-aberto');
    cPosicionar();
  }
  /* Quando a roleta ou o pop-up de tamanho FECHAM (aberto -> fechado), o cartão que esperou aparece. */
  var popupAberto = false;
  if (window.MutationObserver) new MutationObserver(function () {
    var html = document.documentElement;
    var agora = html.classList.contains('tp-roleta-open') || html.classList.contains('tp-pt-open');
    if (popupAberto && !agora && cUltimo) cartaoAtualizar(cUltimo);
    popupAberto = agora;
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  var rodando = false, deNovo = false;
  async function conferir() {
    if (!precisa()) return;
    if (rodando) { deNovo = true; return; }
    rodando = true;
    try {
      var carrinho;
      try { carrinho = await lerCarrinho(); } catch (err) { return; }
      await conferirPresente(carrinho);
    } finally {
      rodando = false;
      if (deNovo) { deNovo = false; agendarConferencia(); }
    }
  }
  var agendado = null;
  function agendarConferencia() {
    clearTimeout(agendado);
    agendado = setTimeout(conferir, 120);
  }

  /* =====================================================================
     POP-UP "SELECIONE O TAMANHO DO SEU PRESENTE MISTERIOSO"
     Markup em sections/tp-rgg-tamanho.liquid, buscado só quando abre.
     Ao confirmar: sorteia a cor entre as variantes do tamanho com SKU em
     estoque na peça de verdade, grava variante + tamanho, avisa a roleta
     (tp:rgg-tamanho) e confere o carrinho.
     ===================================================================== */
  var ptRaiz = null, ptDados = null, ptCarregando = null, ptPediu = false, ptTamanho = null;
  function ptRoot() { try { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; } catch (e) { return '/'; } }
  function ptCarregar() {
    if (ptRaiz) return Promise.resolve(ptRaiz);
    if (ptCarregando) return ptCarregando;
    ptCarregando = fetch(ptRoot() + '?section_id=tp-rgg-tamanho', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var raiz = doc.querySelector('[data-tp-rgg-tamanho]');
        var dados = doc.querySelector('[data-tp-rgg-tamanho-dados]');
        var estilo = doc.querySelector('style');
        if (!raiz || !dados) throw new Error('secao tp-rgg-tamanho sem markup');
        ptDados = JSON.parse(dados.textContent);
        if (estilo) document.head.appendChild(document.importNode(estilo, true));
        ptRaiz = document.importNode(raiz, true);
        document.body.appendChild(ptRaiz);
        ptLigar();
        return ptRaiz;
      })
      .catch(function (e) { console.error('[tp-rgg-presente] pop-up de tamanho', e); ptCarregando = null; throw e; });
    return ptCarregando;
  }
  function ptLigar() {
    var ok = ptRaiz.querySelector('[data-pt-confirmar]');
    var erro = ptRaiz.querySelector('[data-pt-erro]');
    ptRaiz.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-pt-tabela-abrir]')) { ptTabela(true); return; }
      if (ev.target.closest('[data-pt-tabela-fechar]')) { ptTabela(false); return; }
      if (ev.target.closest('[data-pt-fechar]')) { ptFechar(); return; }
      var b = ev.target.closest('[data-pt-tam]');
      if (b && !b.disabled) {
        ptTamanho = b.getAttribute('data-pt-tam');
        [].forEach.call(ptRaiz.querySelectorAll('[data-pt-tam]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        ok.disabled = false; ok.textContent = ptDados.botaoOk || 'Confirmar tamanho';
        erro.hidden = true;
      }
    });
    ok.addEventListener('click', function () {
      if (!ptTamanho) return;
      var doTamanho = ptDados.variantes.filter(function (v) { return v.tamanho === ptTamanho && v.available; });
      var comEstoque = doTamanho.filter(function (v) { return v.sku && ptDados.estoque.indexOf(v.sku) > -1; });
      /* Só cor com estoque na regata original (20/10/2026): sem plano B com cor esgotada. */
      var pool = comEstoque;
      if (!pool.length) { erro.textContent = 'Esse tamanho esgotou. Escolha outro.'; erro.hidden = false; return; }
      var sorteada = pool[Math.floor(Math.random() * pool.length)];
      try {
        localStorage.setItem('tp-rgg-presente-variante', String(sorteada.id));
        localStorage.setItem('tp-rgg-presente-tamanho', ptTamanho);
      } catch (e) {}
      ptFechar();
      try { document.dispatchEvent(new CustomEvent('tp:rgg-tamanho', { detail: { tamanho: ptTamanho } })); } catch (e) {}
      agendarConferencia();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !ptRaiz || ptRaiz.hidden) return;
      var tab = ptRaiz.querySelector('[data-pt-tabela]');
      if (tab && !tab.hidden) ptTabela(false); else ptFechar();
    });
  }
  function ptTabela(abrir) {
    var tab = ptRaiz && ptRaiz.querySelector('[data-pt-tabela]');
    if (!tab) return;
    tab.hidden = !abrir;
    if (abrir) { var sh = tab.querySelector('.tp-pt__tabela-sheet'); if (sh) sh.scrollTop = 0; }
  }
  function ptAbrir() {
    return ptCarregar().then(function (raiz) {
      [].forEach.call(raiz.querySelectorAll('[data-pt-tam]'), function (b) {
        var t = b.getAttribute('data-pt-tam');
        var tem = ptDados.variantes.some(function (v) { return v.tamanho === t && v.available && v.sku && ptDados.estoque.indexOf(v.sku) > -1; });
        b.disabled = !tem;
      });
      /* Texto do pop-up na Moda Praia nova (30/10/2026); fora dela, o do editor (guardado na 1ª vez). */
      var sub = raiz.querySelector('.tp-pt__sub');
      if (sub) {
        if (sub.getAttribute('data-texto-original') === null) sub.setAttribute('data-texto-original', sub.textContent);
        var tipo = window.tpRggPraia.tipo(), peca = tipo === 'maio' ? 'o maiô' : 'o conjunto top + calcinha';
        if (tipo && window.tpRggPraia.noCarrinho()) sub.textContent = 'Ele vai junto com ' + peca + ' do seu carrinho, sozinho, por nossa conta.';
        else if (tipo) sub.textContent = 'Para levá-lo para casa, leve ' + peca + '. Ele entra no seu carrinho sozinho, por nossa conta.';
        else sub.textContent = sub.getAttribute('data-texto-original');
      }
      raiz.hidden = false;
      document.documentElement.classList.add('tp-pt-open');
      ptTabela(false);
      var sheet = raiz.querySelector('.tp-pt__sheet');
      if (sheet) { sheet.scrollTop = 0; try { sheet.focus({ preventScroll: true }); } catch (e) {} }
    }).catch(function () {});
  }
  function ptFechar() {
    if (!ptRaiz) return;
    ptRaiz.hidden = true;
    document.documentElement.classList.remove('tp-pt-open');
  }
  function ptEscolhido() { return ler('tp-rgg-presente-variante'); }
  window.tpRggTamanho = {
    abrir: ptAbrir,
    fechar: ptFechar,
    escolhido: ptEscolhido,
    pedir: function () { if (ptPediu || ptEscolhido()) return; ptPediu = true; ptAbrir(); }
  };

  /* GATILHOS: a roleta avisa quando grava o prêmio; o tema avisa a cada mudança
     do carrinho; e o redesenho da gaveta (troca do <script data-tp-presente>,
     o mesmo sinal que o tp-presente.js usa -- nunca qualquer mutação, o
     cronômetro da gaveta muda todo segundo). */
  var estadoVisto = null, textoVisto = null;
  function estadoMudou() {
    var el = document.querySelector('[data-tp-presente]');
    var txt = el ? el.textContent : null;
    if (el === estadoVisto && txt === textoVisto) return false;
    estadoVisto = el;
    textoVisto = txt;
    return true;
  }
  function iniciar() {
    estadoMudou();
    if (precisaAoCarregar()) conferir();
    document.addEventListener('tp:rgg-presente', agendarConferencia);
    var raiz = document.getElementById('CartDrawer');
    if (raiz && window.MutationObserver) {
      new MutationObserver(function () { if (estadoMudou()) agendarConferencia(); }).observe(raiz, { childList: true, subtree: true });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, agendarConferencia);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
